<template>
  <BreadCrumb PageTitle="Gestion des utilisateurs" />
  <CustomersList />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CustomersList from "../../components/Customers/CustomersList.vue";

export default defineComponent({
  name: "CustomersListPage",
  components: {
    BreadCrumb,
    CustomersList,
  },
});
</script>